import { FontSettings } from '../../CanvasText/type/FontSettings';

export const DefaultFontSettings: FontSettings = {
  fontSize: 320,
  letterSpacing: 20,
  interpolation: 3,
  animationTime: 1800,
  easingAnimation: 'QuadraticInOut',
};
